import styled from "styled-components";

export const Container = styled.div`
    max-width: 13rem;
    display: flex;
    flex-direction: column;

`